import(/* webpackMode: "eager" */ "/app/src/app/[locale]/builder/page.tsx");
